import React from 'react';

/* 
  used in
  #1 /paybill ==> Pay page from menu ==> Transaction History section
*/
function Transaction({ count = 5 }) {
  return (
    <>
      <h5 class="section_title_light mb-4 mt-4 shimmerBG shimmer-text-sm w-45"></h5>

      <div class="card_style_5 mb-3">
        {[...new Array(count)]?.map(
          (el, index) => {
            return (
              <React.Fragment key={index}>
                <div class="card_info card_info1 d-flex subtextcomn justify-content-between align-items-center trlist">
                  <div class="card_info_grp w-50">
                    <h4 class="text-ellipsis shimmerBG shimmer-text-xs w-35">

                    </h4>
                    <p class="m-0 shimmerBG shimmer-text-xs w-85">
                    </p>
                  </div>
                  <div class="card_link card_info_grp_r text-right w-50 d-flex flex-column">
                    <div
                      class="text-right shimmerBG shimmer-text-xs w-30 align-self-end"

                    >
                      <span class="text-lowercase">
                      </span>
                    </div>
                    <p class="m-0 shimmerBG shimmer-text-xs w-40 align-self-end"></p>
                  </div>
                </div>
                {count !== index + 1 && <hr></hr>}
              </React.Fragment>
            );
          }
        )}
      </div>
    </>
  );
}

export default Transaction;
